import React from "react";
import { Row, Col, Table } from "antd";
import dataColumns from "./DataColumns";
import "./css/Report120.css";
function ReportR180({ tableGroup, sumCountGroup}) {
   const { tableR180, } = tableGroup;
   const { sumCountR180, } = sumCountGroup;
  //console.log("tableV120", sumCountV120);
  //96 px
  return (
  <>
  {tableR180 && tableR180.length > 0 ?
    <div className="divA4">
      <div className="divEdge96">
        <Row>
          <Col span={24} className="colcenter" style={{paddingTop: "10px"}}>รายงานสืบทรัพย์ก่อนฟ้อง ตามสถานะยังไม่สืบ หรือยังไม่บอกเลิก</Col>
          <Col span={24} className="colLeft18">ประเภทสัญญา : {sumCountR180[0]?.countType}</Col>
          <Col span={24} className="colLeft18" style={{paddingBottom: "10px"}}>เลือกระยะเวลาขาดการติดต่อ : {sumCountR180[0]?.countDay}</Col> 
          <Col span={24} className="colLeft18"> 
            <Table className="table1" columns={dataColumns} dataSource={tableR180}  pagination={false}/>
          </Col>
          <Col span={2} className="colLeft18"></Col>  
          <Col span={12} className="colLeft24" style={{paddingTop: "20px", paddingBottom: "10px"}}>
          จำนวนสัญญาทั้งหมด : 
          <br/>จำนวนเคสยังไม่สืบทรัพย์ : 
          <br/>จำนวนเคสยังไม่ออกบอกเลิก : 
          </Col> 
          <Col span={5} className="colLeft24" style={{paddingTop: "20px", paddingBottom: "10px"}}>
           {sumCountR180[0]?.countCONTNO}
          <br/>{sumCountR180[0]?.countItemA}
          <br/>{sumCountR180[0]?.countItemB}
          </Col> 

          <Col span={5} className="colLeft24" style={{paddingTop: "20px", paddingBottom: "10px"}}>
           เคส
          <br/>เคส
          <br/>เคส
          </Col>  
        </Row>
      </div>
    </div>
    : []}
   
  </>               
  );
}
export default ReportR180;
